var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "friendly-link mt-30" }, [
    _c("div", { staticClass: "friendly-link-head f-b-c" }, [
      _c("h3", [_vm._v("友情链接")]),
      _c(
        "div",
        [
          _c("el-button", {
            attrs: {
              type: "primary",
              icon: "el-icon-arrow-left",
              size: "mini",
              plain: "",
              disabled: _vm.isFirstPage,
            },
            on: { click: _vm.pagePrev },
          }),
          _c("el-button", {
            staticClass: "ml-10",
            attrs: {
              type: "primary",
              icon: "el-icon-arrow-right",
              size: "mini",
              plain: "",
              disabled: _vm.isLastPage,
            },
            on: { click: _vm.pageNext },
          }),
        ],
        1
      ),
    ]),
    _c(
      "ul",
      { staticClass: "friendly-link-list" },
      _vm._l(_vm.listData, function (link) {
        return _c(
          "li",
          { key: link.id, staticClass: "friendly-link-item" },
          [
            _c(
              "Link",
              {
                staticClass: "flex-center",
                attrs: { to: link.url || "", title: link.name },
              },
              [_c("img", { attrs: { src: link.image, alt: link.name } })]
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }